export default ( path ) => {
    return `/${path.replace(/\/$|$/, `/`)}`
}